import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {AppMetadataApiService} from './appmetadata-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    AppMetadataApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkAppMetadataModule { }
